export default __webpack_public_path__ + "static/media/marauders-map-v4-01-01.3b4c1ab7.jpg";